import { render } from "./HousesPage.vue?vue&type=template&id=d9a7a6b2&scoped=true"
import script from "./HousesPage.vue?vue&type=script&lang=js"
export * from "./HousesPage.vue?vue&type=script&lang=js"

import "./HousesPage.vue?vue&type=style&index=0&id=d9a7a6b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9a7a6b2"]])

export default __exports__